module.exports = __webpack_public_path__ + "static/media/n16.1e844145.jpg";